export default {
    methods: {
        onContentReady (e) {
            e.component.option('loadPanel.enabled', false);
            // e.component.updateDimensions();
        },
    },
};
